<template>
  <div class="row">
    <div class="col-sm-12">
      <table class="table table-striped table-bordered"
        style="table-layout: fixed;"
      >
        <thead>
          <tr>
            <th v-for="column in sortable.columns" :key="column.name"
              @click="column.sortable ? sortBy(column.key) : false"
              class="sortable" :class="sortable.sortColumn === column.key ? 'active-sort' : ''"
              :style="column.sortable ? 'padding-right: 12px;' : ''"
              :width="column.width || 'auto'"
              v-tooltip.top-center="column.tooltip || false"
            >
              <span :style="column.sortable ? 'padding-right: 2px;' : ''">{{ column.name }}</span>
              <i class="fas" style="position: absolute; padding-left: 2px;"
                v-if="column.sortable"
                :class="sortable.sortOrders[column.key] > 0 ? 'fa-sort-up' : 'fa-sort-down'"
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products" :key="product.id"
            is="WarehouseProductToOrderRow"
            :product="product"
            :hideable-columns="hideableColumns"
            @openSuppliers="openSuppliers"
            @openWarehouses="openWarehouses"
          />
        </tbody>
      </table>
    </div>
    <product-suppliers-dialog
      :show="showSuppliers"
      :product="selectedProduct"
      @close="showSuppliers = false"
    />
    <product-warehouses-dialog
      :show="showWarehouses"
      :product-warehouses="productWarehouses"
      @close="showWarehouses = false"
    />
  </div>
</template>

<script>
import ProductSuppliersDialog from 'src/pages/Products/product-suppliers-dialog'
import ProductWarehousesDialog from 'src/pages/Products/product-warehouses-dialog'
import WarehouseProductToOrderRow from './warehouse-product-to-order-row'

export default {
  props: ['products', 'sortable', 'hideableColumns'],
  components: { ProductSuppliersDialog, ProductWarehousesDialog, WarehouseProductToOrderRow },
  data () {
    return {
      productSuppliers: [],
      productWarehouses: [],
      showSuppliers: false,
      showWarehouses: false,
      selectedProduct: null
    }
  },
  methods: {
    openSuppliers ({ productSuppliers, product }) {
      this.selectedProduct = product
      this.showSuppliers = true
    },
    openWarehouses (product) {
      this.$http.get(`/products/${product.id}/warehouses`).then(({ data }) => {
        this.productWarehouses = data
        this.showWarehouses = true
      })
    },
    sortBy (column) {
      this.$emit('sortBy', column)
    }
  }
}
</script>

<style lang="scss" scoped>
  .sortable {
    cursor: pointer;
  }

  .active-sort {
    font-weight: bold;
  }
</style>
